// function styleFormEmbed(formEmbed) {
//   const shadow = formEmbed.shadowRoot;
//   if (!shadow) return;

//   const formContainer = shadow.querySelector("._formContainer_1q1d2_30");
//   if (formContainer) {
//     formContainer.style.cssText = `
//       max-width: 500px;
//       margin: 0 auto;
//     `;
//     formContainer.classList.add("form-styled");
//   }

//   const mobileContainer = shadow.querySelector("._container_3eyaa_70");
//   if (mobileContainer) {
//     mobileContainer.style.cssText = `
//       max-width: 100%;
//       margin: 0 auto;
//       width: 100%;
//       display: flex;
//     `;
//     mobileContainer.classList.add("form-styled");
//   }

//   const formContainerMobile = shadow.querySelector("#form-container-ref");
//   if (formContainerMobile) {
//     formContainerMobile.style.cssText = `
//       max-width: 100%;
//       margin: 0 auto;
//       width: 100%;
//     `;
//     formContainerMobile.classList.add("form-styled");
//   }

//   const header = shadow.querySelector("._formHeader_cit2d_24, section._formHeader_cit2d_24, h2._textHeading_2aowh_35");
//   if (header) {
//     const headerSection = header.closest("section");
//     if (headerSection && !headerSection.classList.contains("form-styled")) {
//       headerSection.style.display = "none";
//       headerSection.classList.add("form-styled");
//     }
//   }

//   const footerText = shadow.querySelector("._formDisclaimer_cit2d_38 p");
//   if (footerText) {
//     footerText.style.cssText = `
//       font-family: 'Afacad', sans-serif;
//       font-weight: 400;
//       font-size: 12px;
//       line-height: 120%;
//       letter-spacing: 0.04em;
//       text-align: center;
//     `;
//     footerText.classList.add("form-styled");
//   }

//   const sectionMain = shadow.querySelector("._gridItemContent_1q1d2_257");
//   if (sectionMain) {
//     const section = sectionMain.closest("div");
//     if (section) {
//       section.classList.add("custom-padding");

//       if (!shadow.querySelector("#custom-form-styles")) {
//         const style = document.createElement('style');
//         style.id = "custom-form-styles";
//         style.textContent = `
//           .custom-padding._gridItemContent_1q1d2_257 { padding: 100px 0px; }
//           @media (max-width: 768px) {
//             .custom-padding._gridItemContent_1q1d2_257 { padding: 24px 0 60px; }
//           }
//         `;
//         shadow.appendChild(style);
//       }
//     }
//   }

//   const internalForm = shadow.querySelector("form");
//   if (!internalForm) return;

//   if (!internalForm.classList.contains("form-styled")) {
//     internalForm.style.padding = "0 0 8px";
//     internalForm.style.gap = "20px";
//     internalForm.classList.add("form-styled");
//   }

//   const inputs = internalForm.querySelectorAll(
//     'input[type="text"]:not(.form-styled), input[type="email"]:not(.form-styled), input[type="password"]:not(.form-styled), input[type="tel"]:not(.form-styled), textarea:not(.form-styled), select:not(.form-styled)'
//   );
//   inputs.forEach((input) => {
//     input.style.cssText = `
//       width: 100%;
//       padding: 13px 20px 0 20px;
//       box-sizing: border-box;
//       margin-bottom: 0;
//       border: 1px solid #E7E3DC;
//       border-radius: 26px;
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//       vertical-align: middle;
//       text-transform: capitalize;
//       color: #294649;
//       height: 45px;
//       box-shadow: none;
//       background-color: transparent;
//       @media (max-width: 768px) {
//         input[type="text"]:not(.form-styled), input[type="email"]:not(.form-styled), input[type="password"]:not(.form-styled), input[type="tel"]:not(.form-styled), textarea:not(.form-styled), select:not(.form-styled) { font-size: 16px; height: 40px; }
//       }
//     `;
//     input.classList.add("form-styled");
//   });

//   const labels = internalForm.querySelectorAll("label:not(.form-styled)");
//   labels.forEach((label) => {
//     label.style.cssText = `
//       top: 10px;
//       left: 20px;
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//       opacity: 0.7;
//       color: #294649;
//       text-transform: capitalize;
//       background-color: transparent;
//       @media (max-width: 768px) {
//         label:not(.form-styled) { font-size: 16px; }
//       }
//     `;
//     label.classList.add("form-styled");
//   });

//   const alerts = internalForm.querySelectorAll("._formError_1ydxd_20");
//   alerts.forEach((alert) => {
//     alert.style.cssText = `
//       font-family: 'Afacad', sans-serif;
//       font-weight: 400;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//     `;
//     alert.classList.add("form-styled");
//   });

//   const legends = internalForm.querySelectorAll("legend:not(.form-styled)");
//   legends.forEach((legend) => {
//     legend.style.cssText = `
//       font-family: 'Afacad', sans-serif;
//       font-weight: 400;
//       font-size: 12px;
//       line-height: 120%;
//       letter-spacing: 0.04em;
//       color: #294649;
//       background-color: transparent;
//     `;
//     legend.classList.add("form-styled");
//   });

//   const successMessage = shadow.querySelector("._textBody_2aowh_10 p");
//   if (successMessage) {
//     successMessage.style.cssText = `
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 18px;
//       line-height: 178%;
//       letter-spacing: 0.02em;
//       text-align: center;
//       vertical-align: middle;
//       color: #294649;
//     `;
//     successMessage.classList.add("form-styled");
//   }

//   const successMessageTitle = shadow.querySelector("._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9");
//   if (successMessageTitle) {
//     successMessageTitle.style.cssText = `
//       font-family: 'Afacad', sans-serif;
//       font-size: 24px;
//     `;
//     successMessageTitle.classList.add("form-styled");
//   }

//   // Style submit buttons specifically
//   const submitButtons = shadow.querySelectorAll('button._formSubmitButton_cit2d_96:not(.form-styled)');
//   submitButtons.forEach((button) => {
//     button.style.cssText = `
//       width: 100%;
//       padding: 13px 20px;
//       box-sizing: border-box;
//       margin-bottom: 0;
//       border: 1px solid #E7E3DC;
//       border-radius: 26px;
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//       vertical-align: middle;
//       text-transform: capitalize;
//       height: 45px;
//       box-shadow: none;
//       cursor: pointer;
//       background-color: #294649;
//       color: #FFFDF9;
//       transition: all 0.3s ease;
//       text-transform: uppercase;
//     `;
//     button.classList.add("form-styled");

//   });

//   // Style select toggle buttons specifically
//   const selectToggleButtons = shadow.querySelectorAll('button._selectToggle_12thd_25:not(.form-styled)');
//   selectToggleButtons.forEach((button) => {
//     button.style.cssText = `
//       width: 100%;
//       padding: 13px 20px;
//       box-sizing: border-box;
//       margin-bottom: 0;
//       border: 1px solid #E7E3DC;
//       border-radius: 26px;
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//       vertical-align: middle;
//       text-transform: capitalize;
//       height: 45px;
//       box-shadow: none;
//       cursor: pointer;
//       background-color: transparent;
//       color: #294649;
//       transition: all 0.3s ease;
//     `;
//     button.classList.add("form-styled");

//     // Only select the arrow inside this button
//     const buttonArrow = button.querySelector("._arrowDownIcon_12thd_19");
//     if (buttonArrow) {
//       buttonArrow.style.cssText = `
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       `;
//       buttonArrow.classList.add("form-styled");
//     }

//   });

//   // Style other buttons (excluding select toggle and submit)
//   const otherButtons = internalForm.querySelectorAll('button:not(.form-styled):not(._selectToggle_12thd_25):not(._formSubmitButton_cit2d_96), button[type="button"]:not(.form-styled):not(._selectToggle_12thd_25):not(._formSubmitButton_cit2d_96)');
//   otherButtons.forEach((button) => {
//     button.style.cssText = `
//       width: 100%;
//       padding: 13px 20px;
//       box-sizing: border-box;
//       margin-bottom: 0;
//       border: 1px solid #E7E3DC;
//       border-radius: 26px;
//       font-family: 'Afacad', sans-serif;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 120%;
//       letter-spacing: 0.02em;
//       vertical-align: middle;
//       text-transform: capitalize;
//       height: 45px;
//       box-shadow: none;
//       cursor: pointer;
//       color: #294649;
//       transition: all 0.3s ease;
//     `;
//     button.classList.add("form-styled");
//   });
// }

// function observeFormEmbedChanges(formEmbed) {
//   const shadow = formEmbed.shadowRoot;
//   if (!shadow) return;

//   const observer = new MutationObserver(() => {
//     styleFormEmbed(formEmbed);
//   });

//   observer.observe(shadow, {
//     childList: true,
//     subtree: true,
//   });
// }

// function runWhenAppEmbedExists() {
//   const formEmbed = document.getElementById("app-embed");
//   if (formEmbed) {
//     const checkShadowRoot = () => {
//       if (formEmbed.shadowRoot) {
//         styleFormEmbed(formEmbed);
//         observeFormEmbedChanges(formEmbed);
//       } else {
//         setTimeout(checkShadowRoot, 100);
//       }
//     };
//     checkShadowRoot();
//     return;
//   }

//   const observer = new MutationObserver((mutations, obs) => {
//     const formEmbed = document.getElementById("app-embed");
//     if (formEmbed) {
//       const checkShadowRoot = () => {
//         if (formEmbed.shadowRoot) {
//           styleFormEmbed(formEmbed);
//           observeFormEmbedChanges(formEmbed);
//           obs.disconnect();
//         } else {
//           setTimeout(checkShadowRoot, 100);
//         }
//       };
//       checkShadowRoot();
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// }

// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', runWhenAppEmbedExists);
// } else {
//   runWhenAppEmbedExists();
// }

function styleFormEmbed(formEmbed) {
  const shadow = formEmbed.shadowRoot;
  if (!shadow) return;

  // Insert a single style block if not already added
  if (!shadow.querySelector("#form-style-block")) {
    const style = document.createElement("style");
    style.id = "form-style-block";
    style.textContent = `
      [data-testid="banner-success"] h2 {
        font-family: 'Afacad', sans-serif !important;
        font-size: 24px !important;
      }

      [data-testid="banner-success"] div {
        font-family: 'Afacad', sans-serif !important;
        font-weight: 500 !important;
        font-size: 18px !important;
        line-height: 178% !important;
        letter-spacing: 0.02em !important;
        text-align: center !important;
        vertical-align: middle !important;
        color: #294649 !important;
      }

      .custom-padding._gridItemContent_1q1d2_257 { padding: 100px 0px; }
      @media (max-width: 768px) {
        .custom-padding._gridItemContent_1q1d2_257 {
          padding: 24px 0 60px;
        }
        [data-testid="banner-success"] div {
          font-size: 16px !important; 
          letter-spacing: 0.04em !important;
        }
        input[type="text"]:not(.form-styled), input[type="email"]:not(.form-styled), input[type="password"]:not(.form-styled), input[type="tel"]:not(.form-styled), textarea:not(.form-styled), select:not(.form-styled) {
          height: 40px !important;
        }
      }
    `;
    shadow.querySelector("div")?.prepend(style);
  }

  const applyStyles = (el, cssText) => {
    if (el && !el.classList.contains("form-styled")) {
      el.style.cssText = cssText;
      el.classList.add("form-styled");
    }
  };

  applyStyles(shadow.querySelector("._formContainer_1q1d2_30"), `
    max-width: 500px;
    margin: 0 auto;
  `);

  applyStyles(shadow.querySelector("._container_3eyaa_70"), `
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
    display: flex;
  `);

  applyStyles(shadow.querySelector("#form-container-ref"), `
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
  `);

  const header = shadow.querySelector("._formHeader_cit2d_24, section._formHeader_cit2d_24, h2._textHeading_2aowh_35");
  const headerSection = header?.closest("section");
  if (headerSection && !headerSection.classList.contains("form-styled")) {
    headerSection.style.display = "none";
    headerSection.classList.add("form-styled");
  }

  applyStyles(shadow.querySelector("._formDisclaimer_cit2d_38 p"), `
    font-family: 'Afacad', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0.04em;
    text-align: center;
  `);

  const sectionMain = shadow.querySelector("._gridItemContent_1q1d2_257");
  const parentSection = sectionMain?.closest("div");
  if (parentSection && !parentSection.classList.contains("custom-padding")) {
    parentSection.classList.add("custom-padding");
  }

  const internalForm = shadow.querySelector("form");
  if (!internalForm) return;

  applyStyles(internalForm, `
    padding: 0 0 8px;
    gap: 20px;
  `);

  const stylizeNodeList = (nodeList, cssText) => {
    nodeList.forEach(el => applyStyles(el, cssText));
  };

  stylizeNodeList(internalForm.querySelectorAll(
    'input[type="text"]:not(.form-styled), input[type="email"]:not(.form-styled), input[type="password"]:not(.form-styled), input[type="tel"]:not(.form-styled), textarea:not(.form-styled), select:not(.form-styled)'
  ), `
    width: 100%;
    padding: 13px 20px 0 20px;
    box-sizing: border-box;
    margin-bottom: 0;
    border: 1px solid #E7E3DC;
    border-radius: 26px;
    font-family: 'Afacad', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.02em;
    vertical-align: middle;
    text-transform: capitalize;
    color: #294649;
    height: 45px;
    box-shadow: none;
    background-color: transparent;
  `);

  stylizeNodeList(internalForm.querySelectorAll("label:not(.form-styled)"), `
    top: 10px;
    left: 20px;
    font-family: 'Afacad', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.02em;
    opacity: 0.7;
    color: #294649;
    text-transform: capitalize;
    background-color: transparent;
  `);

  stylizeNodeList(internalForm.querySelectorAll("legend:not(.form-styled)"), `
    font-family: 'Afacad', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0.04em;
    color: #294649;
    background-color: transparent;
  `);

  stylizeNodeList(internalForm.querySelectorAll("._formError_1ydxd_20"), `
    font-family: 'Afacad', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.02em;
  `);

  applyStyles(shadow.querySelector("._textBody_2aowh_10 p"), `
    font-family: 'Afacad', sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 178%;
    letter-spacing: 0.02em;
    text-align: center;
    vertical-align: middle;
    color: #294649;
  `);

  applyStyles(shadow.querySelector("._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9"), `
    font-family: 'Afacad', sans-serif;
    font-size: 24px;
  `);

  stylizeNodeList(shadow.querySelectorAll('button._formSubmitButton_cit2d_96:not(.form-styled)'), `
    width: 100%;
    padding: 13px 20px;
    box-sizing: border-box;
    margin-bottom: 0;
    border: 1px solid #E7E3DC;
    border-radius: 26px;
    font-family: 'Afacad', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.02em;
    vertical-align: middle;
    text-transform: uppercase;
    height: 45px;
    box-shadow: none;
    cursor: pointer;
    background-color: #294649;
    color: #FFFDF9;
    transition: all 0.3s ease;
  `);

  shadow.querySelectorAll('button._selectToggle_12thd_25:not(.form-styled)').forEach(button => {
    applyStyles(button, `
      width: 100%;
      padding: 13px 20px;
      box-sizing: border-box;
      margin-bottom: 0;
      border: 1px solid #E7E3DC;
      border-radius: 26px;
      font-family: 'Afacad', sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: 0.02em;
      vertical-align: middle;
      text-transform: capitalize;
      height: 45px;
      box-shadow: none;
      cursor: pointer;
      background-color: transparent;
      color: #294649;
      transition: all 0.3s ease;
    `);

    const arrow = button.querySelector("._arrowDownIcon_12thd_19");
    if (arrow) {
      applyStyles(arrow, `
        display: flex;
        align-items: center;
        justify-content: center;
      `);
    }
  });

  stylizeNodeList(internalForm.querySelectorAll(
    'button:not(.form-styled):not(._selectToggle_12thd_25):not(._formSubmitButton_cit2d_96), button[type="button"]:not(.form-styled):not(._selectToggle_12thd_25):not(._formSubmitButton_cit2d_96)'
  ), `
    width: 100%;
    padding: 13px 20px;
    box-sizing: border-box;
    margin-bottom: 0;
    border: 1px solid #E7E3DC;
    border-radius: 26px;
    font-family: 'Afacad', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.02em;
    vertical-align: middle;
    text-transform: capitalize;
    height: 45px;
    box-shadow: none;
    cursor: pointer;
    color: #294649;
    transition: all 0.3s ease;
  `);
}

function observeFormEmbedChanges(formEmbed) {
  const shadow = formEmbed.shadowRoot;
  if (!shadow) return;

  let timeoutId;
  const observer = new MutationObserver(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      styleFormEmbed(formEmbed);
    }, 100); // debounce
  });

  observer.observe(shadow, {
    childList: true,
    subtree: true,
  });
}

function runWhenAppEmbedExists() {
  const formEmbed = document.getElementById("app-embed");
  if (formEmbed) {
    const checkShadowRoot = () => {
      if (formEmbed.shadowRoot) {
        styleFormEmbed(formEmbed);
        observeFormEmbedChanges(formEmbed);
      } else {
        setTimeout(checkShadowRoot, 100);
      }
    };
    checkShadowRoot();
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const formEmbed = document.getElementById("app-embed");
    if (formEmbed) {
      const checkShadowRoot = () => {
        if (formEmbed.shadowRoot) {
          styleFormEmbed(formEmbed);
          observeFormEmbedChanges(formEmbed);
          obs.disconnect();
        } else {
          setTimeout(checkShadowRoot, 100);
        }
      };
      checkShadowRoot();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runWhenAppEmbedExists);
} else {
  runWhenAppEmbedExists();
}